import { render, staticRenderFns } from "./LeftBar.vue?vue&type=template&id=50f674fd&scoped=true&"
import script from "./LeftBar.vue?vue&type=script&lang=ts&"
export * from "./LeftBar.vue?vue&type=script&lang=ts&"
import style0 from "./LeftBar.vue?vue&type=style&index=0&id=50f674fd&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50f674fd",
  null
  
)

export default component.exports